export const MIN_ACCUMULATED_QTY_MODES = {
  ALL: "all",
  CUSTOM: "custom",
};

export function shortcutHasVolSurfaces(row) {
  return (
    Array.isArray(row?.comparison_surfaces) &&
    row.comparison_surfaces.length > 0
  );
}

export function isShortcutSelectedFlag(row) {
  return (
    row?.is_selected === true ||
    row?.is_selected === 1 ||
    row?.is_selected === "1"
  );
}

export function normalizeMinAccumulatedQtyMode(mode) {
  return mode === MIN_ACCUMULATED_QTY_MODES.CUSTOM
    ? MIN_ACCUMULATED_QTY_MODES.CUSTOM
    : MIN_ACCUMULATED_QTY_MODES.ALL;
}

/** Digits and at most one decimal point; blank and negatives are invalid. */
export function isValidMinAccumulatedQtyText(value) {
  if (value === null || value === undefined) return false;
  const text = String(value).trim();
  if (text === "") return false;
  if (!/^\d+(\.\d+)?$/.test(text)) return false;
  return Number(text) >= 0;
}

export function parseMinAccumulatedQty(value) {
  return Number(String(value).trim());
}

export function sanitizeMinAccumulatedQtyInput(raw) {
  let text = String(raw ?? "").replace(/[^\d.]/g, "");
  const firstDot = text.indexOf(".");
  if (firstDot !== -1) {
    text =
      text.slice(0, firstDot + 1) +
      text.slice(firstDot + 1).replace(/\./g, "");
  }
  return text;
}

export function buildVolComparisonRowsPayload(selectedShortcuts) {
  return (selectedShortcuts || []).map((item) => ({
    product_contract_style_id: item.product_contract_style_id,
    comparison_surface_id: item.comparison_surface_id ?? null,
    min_accumulated_qty_mode: normalizeMinAccumulatedQtyMode(
      item.min_accumulated_qty_mode
    ),
  }));
}

export function prepareVolComparisonShortcuts(rows) {
  const shortcuts = (rows || [])
    .filter(shortcutHasVolSurfaces)
    .slice()
    .sort((a, b) => (a?.label || "").localeCompare(b?.label || ""))
    .map((row) => ({
      ...row,
      min_accumulated_qty_mode: normalizeMinAccumulatedQtyMode(
        row.min_accumulated_qty_mode
      ),
    }));

  // Tick from API is_selected only — do not invent a default when all are false.
  const selectedShortcuts = shortcuts.filter(isShortcutSelectedFlag);

  return { shortcuts, selectedShortcuts };
}
